import styled, { css } from "styled-components";

import { theme } from "@/components/bild/theme";
import { IThemeProps } from "@/styles";
import { fadeIn, fadeOut } from "@/styles/utils/Mixins";
import { colors } from "@/styles/Variants";

import { Animation, FADE_DURATION } from "./LightPoll";

const color = colors.bild;
const { margin, fontFamily, breakpoint } = theme;

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export const MainWrapper = styled.main`
  background: ${color.vader25};
  font-family: ${fontFamily.gothamXNarrow};
  font-size: 16px;
  line-height: 1.3;
  width: 100%;
  max-width: 700px;
  overflow: hidden;
  text-align: center;
  > * {
    margin: ${margin.large}px;
    @media ${breakpoint.medium} {
      margin: ${margin.medium}px;
    }
    @media ${breakpoint.small} {
      margin: ${margin.medium}px;
    }
  }
`;

export const Topline = styled.div`
  color: ${color.red500};
  line-height: 1.1;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
  font-size: 20px;
  @media ${breakpoint.medium} {
    font-size: 18px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const Headline = styled.h1`
  font-family: ${fontFamily.gothamCondensed};
  line-height: 1;
  font-weight: 700;
  color: ${color.vader500};
  font-size: 40px;
  @media ${breakpoint.medium} {
    font-size: 36px;
  }
  @media ${breakpoint.small} {
    font-size: 32px;
  }
`;

type OptionsWrapperProps = IThemeProps<{
  $animation?: Animation;
}>;
export const OptionsWrapper = styled.div<OptionsWrapperProps>`
  ${(props: OptionsWrapperProps) =>
    props.$animation === Animation.FADE_OUT &&
    css`
      animation: ${fadeOut} ${FADE_DURATION}ms ease-out;
    `}
  ${(props: OptionsWrapperProps) =>
    props.$animation === Animation.FADE_IN &&
    css`
      animation: ${fadeIn} ${FADE_DURATION}ms ease-out;
    `}
  animation-fill-mode: forwards;
`;

export const Footer = styled.footer`
  color: ${color.vader300};
  font-size: 18px;
  @media ${breakpoint.medium} {
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    font-size: 16px;
  }
`;

export const Participant = styled.span`
  margin-right: 4px;
  font-weight: 700;
  &:nth-child(2n) {
    margin-right: 20px;
  }
`;
